module.exports = __webpack_public_path__ + "static/media/restaurant_cover.973a578d.png";